<template>
	<div>
	<v-container fluid>
		<v-row	
			justify = "center"
		>
	
			<v-col 
				xl   = "8"
				lg   = "8"
				md   = "11"
				sm   = "11"
				xs   = "12"
				cols = "12"
			>
				<v-spacer></v-spacer>	
				<v-card outlined>
					<v-card-title
						class = "justify-center body-1 secondary pa-1 white--text"
					>
					
					<v-icon 
						small 
						color  = "white"
						class  = "ml-1"
						@click = "$router.back()"
					>
						mdi-arrow-left-circle
					</v-icon>
					
					<v-spacer></v-spacer>
						
					<v-icon 
						 
						color = "primary"
						class = "mr-2"

					>
						mdi-diving-scuba
					</v-icon>
					<span>
						{{ $ml.get(type_device) }}
					</span>
					
					<v-spacer></v-spacer>

						
					<!-- <v-btn			
						x-small				
						outlined
						icon				
						
						class="mr-2 error"

						@click="actions('close_modal')"
					>
						<v-icon 
							x-small 
							color="white"
							
							outlined
						>mdi-close</v-icon>
					</v-btn> -->
					</v-card-title>

					<v-spacer></v-spacer>
					<v-card-text
						class="pb-1"
					>
						<v-row >

							<v-col 
								:xl 	= "12"
								:lg 	= "12"
								:md 	= "12"
								:sm 	= "12"
								:xs 	= "12"
								:cols 	= "12"								
							>
							
								<input_fields
									key 				= "fields_category"
									:input_info 		= "inf.input_info"
									:action_info 		= "action_to_field.action"
									:set_info 			= "action_to_field.info"
									@recive_info_field  = "recive_info($event, 'field')"
									@checking_rtsp 		= "disabled_register = $event"
									@open_relay_modal   = "open_relay_modal"
								></input_fields>
							</v-col>
						</v-row>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn		
							x-small				
							v-text 		= "$ml.get('get_arduinos')"	
							@click 		= "actions('get_arduinos')"
							color 		= "primary"
							
							v-show 		= "!loading_register && show.get_arduinos"
						></v-btn>
						<v-btn		
							x-small				
							v-text 		= "$ml.get('register')"	
							@click 		= "actions('save')"
							color 		= "primary"
							:disabled 	= "disabled_register"
							v-show 		= "!loading_register"
						></v-btn>
						<!-- <v-btn
						

							@click = "test"
						>
							test
						</v-btn> -->
						<v-progress-linear
					      	indeterminate
							v-show = "loading_register"
					      	color  = "primary"
						></v-progress-linear>

						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>	
	</v-container>

	<!-- Modal para seleccionar relay -->
	<v-dialog
		v-model="dialog_relays"
		max-width="800"
		persistent
	>
		<v-card>
			<v-card-title class="secondary white--text">
				<v-icon class="mr-2">mdi-switch</v-icon>
				{{ $ml.get('searching_relays') || 'Buscando Relays...' }}
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="pa-4">
				<!-- Loading -->
				<v-row v-if="loading_relays" justify="center" class="py-8">
					<v-col cols="12" class="text-center">
						<v-progress-circular
							indeterminate
							color="primary"
							size="64"
						></v-progress-circular>
						<p class="mt-4">{{ $ml.get('searching') || 'Buscando relays disponibles...' }}</p>
					</v-col>
				</v-row>

				<!-- Tabla de resultados -->
				<v-row v-else-if="list_relays && list_relays.length > 0">
					<v-col cols="12">
						<v-data-table
							:headers="headers_relays"
							:items="list_relays"
							:items-per-page="10"
							class="elevation-1"
							item-key="serial"
							@click:row="select_relay"
						>
							<template v-slot:item.serial="{ item }">
								<strong>{{ item.serial }}</strong>
							</template>
							<template v-slot:item.ip="{ item }">
								{{ item.ip }}
							</template>
							<template v-slot:item.inputs="{ item }">
								{{ item.inputs.count }} inputs
							</template>
							<template v-slot:item.relays="{ item }">
								{{ item.relays.count }} relays
							</template>
							<template v-slot:item.actions="{ item }">
								<v-btn
									small
									color="primary"
									@click="select_relay(item)"
								>
									{{ $ml.get('select') || 'Seleccionar' }}
								</v-btn>
							</template>
						</v-data-table>
					</v-col>
				</v-row>

				<!-- Sin resultados -->
				<v-row v-else-if="!loading_relays && list_relays && list_relays.length === 0" justify="center" class="py-8">
					<v-col cols="12" class="text-center">
						<v-icon size="64" color="grey">mdi-alert-circle-outline</v-icon>
						<p class="mt-4">{{ $ml.get('no_relays_found') || 'No se encontraron relays disponibles' }}</p>
						<v-btn
							color="primary"
							class="mt-4"
							@click="get_relays"
						>
							<v-icon left>mdi-refresh</v-icon>
							{{ $ml.get('retry_search') || 'Buscar de nuevo' }}
						</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-btn
					text
					color="primary"
					@click="get_relays"
					:disabled="loading_relays"
					v-if="!loading_relays"
				>
					<v-icon left small>mdi-refresh</v-icon>
					{{ $ml.get('retry_search') || 'Buscar de nuevo' }}
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn
					text
					color="error"
					@click="close_relay_modal"
				>
					{{ $ml.get('close') || 'Cerrar' }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	</div>
</template>
<script>
	import input_fields from '@/components/info/input_fields.vue'
	import axios 		from 'axios'
	import Eventbus 	from '@/event-bus'
	import cam_test 	from '@/components/cam_test.vue'
	import { debounce } from '@/helpers/debounce.js'
	
	export default{
		name: 'new_peripheral',
		components:{
			input_fields,
			cam_test
		}, // components

		props:[
			// 'type_dev',
			// 'is_open',
		],
		data: (vm) => ({
			dialog 	: false,
			inf 	: {
				input_info:[
				{
						key: 'type',
						text:'type',
						type: 'select',
						icon: 'mdi-format-list-bulleted-type',
						items 		: ['IP_CAM','PERIPHERAL'],						
						placeholder : '',
						show : false,
						cols: {

							xl: '12',
							lg: '12',
							md: '12',
							xs: '12',
							cols: '12',
						}
					},
					{
						//'name device',						
						key 	: 'name',
						text 	: 'name',
						tooltip : 'help_name_peripheral',
						type 	: 'text',
						icon 	: "mdi-map-marker",
						rules 	: [							
							value => value && value.length >= 4 || 'Min 4 characters'				
						],
						counter_active 	: true,
						show 			: true,
						cols 			: {

							xl 		: '4',
							lg 		: '4',
							md 		: '4',
							xs 		: '12',
							cols 	: '12',
						}
					},
					{
						key 		: 'type_peripheral',
						text 		: 'type_peripheral',
						tooltip 	: 'help_type_peripheral',
						placeholder : 'Type Peripheral',
						text1 		: '1',
						type 		: 'select',
						items 		: ['siren','electronic_lock', 'arduino', 'iot_relay', 'odroid'],
						icon 		: 'mdi-diving-scuba',
						show 		: true,
						cols 		: {

							xl 		: '4',
							lg 		: '4',
							md 		: '4',
							xs 		: '12',
							cols 	: '12',
						}
					},
					{
						key 		: 'arduino',
						text 		: 'arduino',
						tooltip 	: 'help_arduino',
						placeholder : 'arduino',
						text1 		: '',
						type 		: 'select',
						key_list    : "list_arduinos",
						items 		: [],
						icon 		: 'mdi-form-select',
						show 		: false,
						return_obj  : true,
						item_text 	: "path",
						item_value  : "",
						clearable  	: true,
						cols 		: {

							xl 		: '4',
							lg 		: '4',
							md 		: '4',
							xs 		: '12',
							cols 	: '12',
						}
					},
					{
						key 		: 'relay',
						text 		: 'relay',
						tooltip 	: 'help_relay',
						placeholder : 'Relay',
						text1 		: '',
						type 		: 'select',
						key_list    : "list_relays",
						items 		: [],
						icon 		: 'mdi-switch',
						show 		: false,
						return_obj  : true,
						item_text 	: "serial",
						item_value  : "",
						clearable  	: true,
						cols 		: {

							xl 		: '4',
							lg 		: '4',
							md 		: '4',
							xs 		: '12',
							cols 	: '12',
						}
					},										
					{
						key: 'medium',
						text:'medium',
						tooltip: 'help_medium',
						type: 'select',
						items:['USB','TCP', 'GPIO', 'HTTP'],
						icon  : "mdi-connection",
						value : '0',
						show : true,
						cols: {

							xl 		: '4',
							lg 		: '4',
							md 		: '4',
							xs 		: '12',
							cols 	: '12',
						}
					},
					
					{
						key: 'ip',
						text:'ip',
						tooltip: 'help_ip',
						type: 'text',
						icon 	: "mdi-ip-outline",
						value : '0',
						show : false,
						cols: {

							xl 		: '4',
							lg 		: '4',
							md 		: '4',
							xs 		: '12',
							cols 	: '12',
						}
					},
					{
						key: 'serial',
						text:'serial',
						tooltip: 'help_serial',
						type: 'text',
						icon 	: "mdi-serial-port",
						value : '0',
						show : false,
						cols: {

							xl 		: '4',
							lg 		: '4',
							md 		: '4',
							xs 		: '12',
							cols 	: '12',
						}
					},
					{
						key: 'username',
						text:'username',
						tooltip: 'help_username',
						type: 'text',
						icon 	: "mdi-account",
						value : '',
						show : false,
						cols: {

							xl 		: '4',
							lg 		: '4',
							md 		: '4',
							xs 		: '12',
							cols 	: '12',
						}
					},
					{
						key: 'password',
						text:'password',
						tooltip: 'help_password',
						type: 'password',
						icon 	: "mdi-lock",
						value : '',
						show : false,
						cols: {

							xl 		: '4',
							lg 		: '4',
							md 		: '4',
							xs 		: '12',
							cols 	: '12',
						}
					},
					{
						key: 'token',
						text:'token',
						tooltip: 'help_token',
						type: 'text',
						icon 	: "mdi-key",
						value : '',
						show : false,
						cols: {

							xl 		: '4',
							lg 		: '4',
							md 		: '4',
							xs 		: '12',
							cols 	: '12',
						}
					},
					{
						key: 'host',
						text:'host',
						tooltip: 'help_host',
						type: 'text',
						icon 	: "mdi-server",
						value : '',
						show : false,
						cols: {

							xl 		: '4',
							lg 		: '4',
							md 		: '4',
							xs 		: '12',
							cols 	: '12',
						}
					}

				],
				info : {},

			},
			action_to_field 	: {
				action : '',
			},
			// table
			header_table: [
				{ text: vm.$ml.get('name'), value: 'name' },
				// { text: vm.$ml.get('type'), value: 'type' },
				{ text: vm.$ml.get('actions'), value: 'actions', align: 'center' },

				/*{ text: 'Name', value: 'name' },
				{ text: 'IP', value: 'ip' },
				{ text: 'action', value: 'action', align: 'center' },*/
			],
			options 			: { itemsPerPage: 30 },
			total 				: 1,
			list 				: [],
			layout_height 		: 250,
			show_list 			: false,
			type_device 		: '',
			dialog_connection 	: false,
			info_onvif 			: {},
			fields_onvif 		: [
				{
					key: "user",
					text: "user",
					type: "text",					
				},
				{
					key: "password",
					text: "password",
					type: "password",					
				},				
			],
			info_to_stream : {
				id_stream : null,
				name 	  : 'New Device',
			},
			loading_onvif 	  : false,
			disabled_register : true,
			loading_register  : false,
			list_builder 	  : [
				'id',
				// 'rtsp',
				// 'rtsp2',
				'name',
				// 'deviceId',
				// 'user',
				// 'password',
				// 'is_record',
				// 'limit',
				// 'capacity',
				// 'channel_record',
				// 'is_motion',
				// 'channel_retransmission',
				// 'video_for_display',
				'type_peripheral',
				//'pin',
				'medium',
				'ip',
				//'mode',
				'serial',
				'arduino',
				'relay',
				'username',
				'password',
				'token',
				'host',

			],
			show 		: {
				get_arduinos : false,
			},
			dialog_relays	: false,
			loading_relays	: false,
			list_relays		: [],
			headers_relays	: [
				{ text: 'Serial', value: 'serial', align: 'start' },
				{ text: 'IP', value: 'ip' },
				{ text: 'Inputs', value: 'inputs' },
				{ text: 'Relays', value: 'relays' },
				{ text: 'Acciones', value: 'actions', align: 'center', sortable: false },
			],

		}), // data
		created(){
			if (localStorage.getItem('type_Device')) {
				const type_dev = JSON.parse(localStorage.getItem('type_Device'))
				this.type_device = type_dev;
			}
			// console.log(this.check_rtsp("rtsp://Admin:ebenezer890@193.178.3.37/stream2"), 'check_rtsp')
		}, // created

		watch:{
			is_open: function(val){
				if (val) {
					this.dialog=true;
				}
			}, // is open


			options: {
				handler(){
					this.get_list();
				}, deep: true
			}, // options
		}, // watch
		methods:{
			test(){
				Eventbus.$emit('start_installation_progress', {name:'test'});
			},
			recive_info(val, from){
			
				if (val.action == 'save') {
					console.log('step 4, recive');
					this.inf.info = val.value;
					this.save();
				}
			}, // recive_info
			open_relay_modal(){
				this.dialog_relays = true;
				this.loading_relays = true;
				this.list_relays = [];
				this.get_relays();
			}, // open_relay_modal
			close_relay_modal(){
				this.dialog_relays = false;
				this.loading_relays = false;
				this.list_relays = [];
			}, // close_relay_modal
			get_relays(){
				const api = this.$URL + "/api/v1/mqtt/relays/info?timeout=2";
				this.loading_relays = true;
				this.list_relays = []; // Limpiar lista anterior
				this.$axios.get(api).then(res => {
					this.loading_relays = false;
					console.log('Response from get_relays:', res.data);
					// La respuesta tiene la estructura: { success: true, data: { peripherals: [...] } }
					if (res && res.data && res.data.success && res.data.data && res.data.data.peripherals && res.data.data.peripherals.length > 0) {
						this.list_relays = res.data.data.peripherals.map(relay => ({
							serial: relay.serial,
							ip: relay.ip,
							inputs: relay.inputs,
							relays: relay.relays,
							topics: relay.topics
						}));
						console.log('Processed relays list:', this.list_relays);
					} else {
						this.list_relays = [];
						console.warn('No relays found in response:', res.data);
					}
				}).catch(er => {
					this.loading_relays = false;
					this.list_relays = [];
					console.error("Error get relays ", er);
					this.$EventBus.$emit('notifications_modal', {
						type: 'error',
						message: this.$ml.get('error_loading_relays') || 'Error al cargar los relays'
					});
				});
			}, // get_relays
			select_relay(relay){
				// Solo actualizar los campos serial, ip y relay sin tocar los demás
				// No actualizar inf.info completo para preservar el estado del formulario
				// Establecer la acción y solo los campos que queremos actualizar
				this.action_to_field.action = 'update_fields';
				this.action_to_field.info = {
					serial: relay.serial,
					ip: relay.ip,
					relay: relay
				};
				// También actualizar inf.info para que se guarde correctamente
				if (!this.inf.info) {
					this.inf.info = {};
				}
				this.$set(this.inf.info, 'serial', relay.serial);
				this.$set(this.inf.info, 'ip', relay.ip);
				this.$set(this.inf.info, 'relay', relay);
				// Cerrar modal
				this.close_relay_modal();
			}, // select_relay
			actions(act, item){
				let vm = this;

				if (act == 'save' ) {
					console.log('step 1');
					this.action_to_field.action = act;
					
				}
				if (act == 'connect_onvif') { // before connect
					this.dialog_connection = true;
					this.info_onvif = item;

				}
				if (act == 'connection_onvif') { // connection
					this.loading_onvif = true;
					let msg = 'Connection Fail';

					Eventbus.$emit('connection_onvif', this.info_onvif);

					Eventbus.$on('res_connection_onvif', (action) => {
						this.loading_onvif = false;
						
						Eventbus.$emit('notifications_modal', {
							type: 'connection',
							message: msg
						})
					});
					const timer = setTimeout( () =>{
						vm.loading_onvif = false;						
						Eventbus.$emit('notifications_modal', {
							type: 'connection',
							message: msg
						})
						clearTimeout(timer);
					}, 10000)
					// this.dialog_connection = false;
					// console.log("connection onvif");
				}
			}, // actions
			get_list(){
				const { itemsPerPage, page } = this.options;
				const api = this.$URL + '/api/v1/onvif/?page='+page;
				
				axios.defaults.withCredentials = false;
				axios.get(api).then( res => {
					console.log(res, 'res get_list');
					let items 	= res.data.rows;
					this.total 	= res.data.count;
					
					this.list 	= items;
				}).catch( er => {
					console.log(er, 'Error get_list');
				})


			}, // get list

			save(){
				if (!this.$store.getters["auth/permission"]("device", "can_add", "device") ) {
					this.$EventBus.$emit("notifications_modal",{
						type 		: "warning",
						message 	: this.$ml.get("no_have_permission_create") + ' : ' + this.$ml.get("device"),
					});
					this.action_to_field.action = '1';					
					return false
				}
				let temp 		= this.inf.info;
				console.log("save ", temp)
				let info_up 	= this.$Helper.format_req(temp, this.list_builder);
				// Mapear username a user para el request
				if (info_up.username !== undefined) {
					info_up.user = info_up.username;
					delete info_up.username;
				}
				// Asegurar que token y host se envíen incluso si están vacíos
				if (temp.token !== undefined) {
					info_up.token = temp.token;
				}
				if (temp.host !== undefined) {
					info_up.host = temp.host;
				}
				info_up.type 	= "PERIPHERAL";
				// Si es PERIPHERAL, usar ip_machine solo si ip está vacío o null
				if (!info_up.ip || info_up.ip === '' || info_up.ip === null) {
					if (temp.ip_machine) {
						info_up.ip = temp.ip_machine;
					}
				}
				/*if (temp.capacity && temp.limit) {
					info_up.limit = this.$Helper.convert_capacity(temp.capacity, temp.limit, 'string');

				}			*/
				// info_up.is_motion = !info_up.is_motion;


				if (this.$is_docker) {
					let temp_name = location.hostname.split(".");
					temp_name     = temp_name[0] + '-' + info_up.name;
					info_up.name  = temp_name.trim();					
				}


				if (info_up.name) {					
					if (info_up.name) {
						info_up.name = info_up.name.split(' ').join('_');
					}
					this.loading_register = true;		

					const api = this.$URL + '/api/v1/device';

					// Init installation
					Eventbus.$emit('logs_install_image', info_up); // start_installation_progress
					// 
					this.$axios.post(api, info_up).then( res => {
						console.log(res.data, 'res device')
						this.action_to_field.action = '1';

						// Notification
						/*Eventbus.$emit('notifications_modal', {
							type: 'saved'
						});*/
						const inf_setting = res.data;
						// Si el dispositivo es PERIPHERAL, usar ip_machine solo si ip está vacío o null
						if (inf_setting && inf_setting.type === 'PERIPHERAL') {
							if (!inf_setting.ip || inf_setting.ip === '' || inf_setting.ip === null) {
								if (inf_setting.ip_machine) {
									inf_setting.ip = inf_setting.ip_machine;
								}
							}
						}
						localStorage.setItem('settings_device', JSON.stringify({ inf_setting }) );

						this.$store.commit("Devices/concat_devices", res.data);
						

						// Change sidebar and active motion
						/*this.$EventBus.$emit('render_modules', {
							name: 'new_device',
							associate: inf_setting,
						});*/
						// this.get_list();

						// Change route
						let vm = this;
						const timer = setTimeout( () =>{
							this.loading_register = false;
							// vm.$router.push();
							Eventbus.$emit('redirect_view', 'setting_device');
							clearTimeout(timer)
						}, 3000)
					}).catch( er => {
						this.action_to_field.action = '1';
						Eventbus.$emit('notifications_modal', {
							type: 'error'
						});
						this.loading_register = false;
						console.log(er, 'Error save')
					}) 

				}else{
					let msg = '';
					/*if (!this.check_rtsp(info_up.rtsp)) {
						msg += this.$ml.get('rtsp') + ' : '+ this.$ml.get('no_valid');
					}*/
					if (!info_up.name) {
						msg += msg ? ', ' : '';  
						msg += this.$ml.get('required') + ' : ' + this.$ml.get('name');
					}
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'error',
						message : msg
					});
				}
			}, // save

			update(){
				// console.log('step 5, save');
				let info_up = this.inf.info;
				// Mapear username a user para el request
				if (info_up.username !== undefined) {
					info_up.user = info_up.username;
					delete info_up.username;
				}
				// Asegurar que token y host se envíen incluso si están vacíos
				if (info_up.token === undefined && this.inf.info.token !== undefined) {
					info_up.token = this.inf.info.token;
				}
				if (info_up.host === undefined && this.inf.info.host !== undefined) {
					info_up.host = this.inf.info.host;
				}
				// console.log('info to save', info_up);
				const api 	= this.$URL + '/api/v1/device';
				

				axios.defaults.withCredentials = false;
				axios.post(api, info_up).then( res => {
					console.log(res.data, 'res device')
						this.action_to_field.action = '1';
					Eventbus.$emit('notifications_modal', 'saved');
					this.get_list();
				}).catch( er => {
					Eventbus.$emit('notifications_modal', 'error');
					console.log(er, 'Error save')
				}) 
			}, // update
			// https://stackoverflow.com/questions/42199956/how-to-implement-debounce-in-vue2/53486112#53486112
			debounce_input(){
				
				debounce(function (newVal) {
			        this.debouncedInput = newVal
			      }, 500)
			}, // debounce input

			check_rtsp(str_url){
				//rtsp:\/\/\w{1,20}:\w{1,20}@\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3} // no work
				//for multiple checks
				/*"^((https|http|ftp|rtsp|mms)?://)" 
				   + "([0-9a-z_! *'(), &=+$%-]+:)?" [0-9a-z_! *'(), =+$%-]+ *)?"//ftp user?" "@ 
				      + "(([0-9] {1,3}){3} [0-9] {1,3}"// IP form URL - 199.194.52.184 
				      + "|"// Allow IP and DOMAIN (domain name)
				      + "([0-9a-z_! *'()-]+_)*"//domain name - www. 
				      + "([0-9a-z] [0-9a-z-]{0,61})? [0-9a-z]"//secondary domain name 
				      + "[a-z]{2,6})" // first level domain- .com or .museum 
				      + "(: [0-9] {1,4})?"//Port-:80 
				      + "((/?)|" // a slash isn't required if there is no file name 
				      + "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";*/

				let strRegex = `(rtsp):\/\/([^\s@/]+)@([^\s/:]+)(?::([0-9]+))?(\/.*)` ;
				let strRegex1 = `rtsp:\/\/\w{1,20}:\w{1,20}@\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3`;
				let strRegex2 =  "(https?|rtsp|qvmc|rtmp):\\/\\/(?:([^\\s@\\/]+?)[@])?([^\\s\\/:]+)(?:[:]([0-9]+))?(?:(\\/[^\\s?#]+)([?][^\\s#]+)?)?([#]\\S*)?";
				// "(https?|rtsp|qvmc|rtmp):\/\/(?:([^\s@\/]+?)[@])?([^\s\/:]+)(?:[:]([0-9]+))?(?:(\/[^\s?#]+)([?][^\s#]+)?)?([#]\S*)?";
					let re  = new RegExp(strRegex);
					let re1 = new RegExp(strRegex1);
					let re2 = new RegExp(strRegex2);
					/*//re.test()
					let check_valid = str_url.split(":");
					let check = true;
					if (check_valid[0] !== "rtsp") {
						check = false;
					}else{
						let temp = new RegExp(`[//]`);
						if (!temp.test(check_valid[0])) {
							check = false;
						}
					}*/
					
					// console.log(re.test(str_url) , re1.test(str_url));
					if (re.test(str_url) || re1.test(str_url) || re2.test(str_url)){
						return (true);
					}else{
						return (false);
					}
			}, // check rtsp


			
		}, // methods
		computed: {
			render_list: function(){
				return this.list;
			},
		}, // computed

		mounted(){
			// Eventbus.$on('connection_new_device', (action) =>{
				
			// })
		}, // mounted
	};
</script>
